<template>
  <div>
    <section v-for="service in data" :key="service.name" class="app-list">
      <h2 class="app-list-title">
        {{ service.name }}
      </h2>
      <v-row class="app-list-services">
        <v-col
          v-for="item in service.list"
          :key="item.name"
          cols="6"
          sm="6"
          md="3"
          xs="6"
          class="app-list-services__item"
        >
          <router-link
            v-if="!item.external && !item.disabled"
            :to="`${service.url}${item.url}`"
            :class="['app-list-services__link', { disabled: item.disabled }]"
            :title="item.name"
          >
            <div class="area-icon">
              <v-icon class="icon">
                {{ item.icon }}
              </v-icon>
            </div>
            <span class="title">{{ item.name }}</span>
          </router-link>
          <a
            v-else-if="item.external && !item.disabled"
            :href="item.url"
            :class="['app-list-services__link', { disabled: item.disabled }]"
            :title="item.name"
            target="_blank"
          >
            <div class="area-icon">
              <v-icon class="icon">
                {{ item.icon }}
              </v-icon>
            </div>
            <span class="title">{{ item.name }}</span>
          </a>
          <div
            v-else-if="item.disabled"
            :class="['app-list-services__link', 'disabled']"
            :title="item.name"
          >
            <div class="area-icon">
              <v-icon class="icon">
                {{ item.icon }}
              </v-icon>
            </div>
            <span class="title">{{ item.name }}</span>
          </div>
        </v-col>
      </v-row>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ServicesList',
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.app {
  &-list {
    margin-top: 20px;
    &-title {
      color: #58595b;
      margin: 0px;
      font-size: 20px !important;
      font-weight: 400 !important;
    }
  }
  &-list-services {
    &__link {
      background-color: #fff;
      display: block;
      border-radius: 10px;
      //box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.08);
      box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.08);
      height: 125px;
      width: 100%;
      display: flex;
      align-items: center;
      flex-direction: column;
      flex-flow: column;
      text-align: center;
      justify-content: center;
      padding: 10px 20px;
      &:hover:not(.disabled) {
        background-color: #1976d2;
        transition: background 0.1s ease-in;
        .title {
          color: #fff;
        }
      }
      &.disabled {
        opacity: 0.5;
        cursor: not-allowed;
        pointer-events: none;
      }
      .area-icon {
        display: flex;
        align-items: center;
        background-color: #f5f5f5;
        padding: 10px;
        border-radius: 50px;
        width: 60px;
        height: 60px;
      }
      .icon {
        color: #1976d2;
        font-size: 25px;
        margin: auto;
      }
      .title {
        color: #58595b;
        line-height: 15px;
        font-size: 15px !important;
        margin-top: 5px;
      }
    }
  }
}
</style>
